// extracted by mini-css-extract-plugin
export default {"productDescription":"S--z","featuredDescription":"T--z","description":"U--z","more":"V--z","descriptionSku":"W--z"};